import { render, staticRenderFns } from "./AdminDetaljiAkreditora.vue?vue&type=template&id=2eb4a386&"
import script from "./AdminDetaljiAkreditora.vue?vue&type=script&lang=js&"
export * from "./AdminDetaljiAkreditora.vue?vue&type=script&lang=js&"
import style0 from "./AdminDetaljiAkreditora.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports